import { BIOMES, THEMED_SLOTS, type ThemedSlotType, type WorldMapNode } from '@goodtime/shared';

/** Map a biome index → wheel-room themeId. The themeId travels through
 * to the server's GameRoom row + drives the eventual theme art on the
 * wheel screen. Names match {@code apps/mobile/src/assets/environment/}
 * so the same string keys env art on the client. */
export function themeIdForBiome(biomeIdx: number): string {
  const biome = BIOMES[biomeIdx];
  if (!biome) return 'forest';
  switch (biome.id) {
    case 'kingdom':  return 'forest';
    case 'cove':     return 'underwater';
    case 'frost':    return 'frost';
    case 'frontier': return 'frontier';
    case 'neon':     return 'neon';
    case 'candy':    return 'sherbet_square';
    default:         return 'forest';
  }
}

/** Themed-slot nodes carry their theme in the node type itself
 *  (royal_reels → 'royal', etc.) and bypass the biome-level default;
 *  the mapping is looked up from the {@link THEMED_SLOTS} registry so
 *  new themed slots need no edit here. Plain `slot` nodes still fall
 *  back to the biome theme (Forest Reels in Kingdom, Neon Reels in
 *  Neon Heights, etc.). */
export function themeIdForNode(node: WorldMapNode): string {
  const themed = THEMED_SLOTS[node.type as ThemedSlotType];
  if (themed) return themed.theme;
  return themeIdForBiome(node.biome);
}
